<template>
  <preview-pane :loaded="!loading" :title="'test'">
    <!-- Job not found header template -->
    <template v-slot:header v-if="error">
      <v-toolbar dense flat class="minitoolbar">
        <v-spacer />
        {{ $t("servicesystem.common_objects.fallbackterms.no job_actions") }}
      </v-toolbar>
    </template>
    <!-- Job header template -->
    <template v-slot:header v-else>
      <v-toolbar dense flat class="minitoolbar">
        <v-btn v-if="closePreviewFunc != undefined" icon small class="mr-2" @click="closePreviewFunc()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <h4 class="mt-1">{{ articleNumber }}</h4>
        <v-spacer />

        <v-btn color="primary" small @click="open()">
          <v-icon class="mr-2" size="15" v-text="'open_in_full'" />
          {{ $t("servicesystem.common_objects.commonterms.open") }}
        </v-btn>
        <action-menu :actionList="actionlist" :parentcontext="thiscontext" class="ml-2"> </action-menu>
      </v-toolbar>
    </template>
    <!-- Job not found content template -->
    <template v-slot:content>
      <empty-page v-if="error" :icon="'mdi-briefcase-remove'"
        :title="$t('servicesystem.common_objects.fallbackterms.no job')" :message="$t('servicesystem.common_objects.fallbackterms.failed_find_job', { jkey: $route.params.jobId })
          ">
      </empty-page>
      <v-container v-else-if="article" class="pa-0" style="background-color: white; border-left: 1px solid black;">
        <!-- 
        <v-row no-gutters>
          <ArticleImage :relativePath="article.ArticleImage" :size="130">
          </ArticleImage>
        </v-row>
        <h4>Pricing</h4>
        <v-row no-gutters>
          <v-col>
            Default price:
            {{ article.ArticlePrice }}
          </v-col>
          <v-col>
            Internal cost:
            {{ article.ArticlePriceIn }}
          </v-col>
          <v-col>
            Vat:
            {{ article.VatRate }}
          </v-col>
        </v-row>
        <v-divider></v-divider>
        -->
        <ArticleEditContent :originalItem="article" :editItem="article" readonly>
        </ArticleEditContent>

      </v-container>
    </template>
    <template v-slot:buttons>
      <v-btn @click="$store.state.triggerevents.previewCloseTrigger++" outlined color="close">{{
        $t("servicesystem.common_objects.commonterms.close") }}
      </v-btn>
      <v-btn @click="open()" color="primary">{{ $t("servicesystem.common_objects.commonterms.open") }} </v-btn>
    </template>
  </preview-pane>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ActionMenu from "@/components/Buttons/ActionMenu.vue";
import EmptyPage from "@/components/Sections/EmptyPage.vue";
import PreviewPane from "@/views/layouts/PreviewPane.vue";
import ArticleEditContent from "@/views/pim/articles/ArticleEditContent.vue";
//import ArticleImage from "@/views/pim/articles/ArticleImage.vue";

export default {
  name: "PreviewArticle",
  props: {
    articleNumber: String,
    closePreviewFunc: Function,
  },
  components: {
    PreviewPane,
    ActionMenu,
    EmptyPage,
    ArticleEditContent,
    //ArticleImage,
  },
  mixins: [clientAPI],

  data() {
    return {
      thiscontext: this,
      actionlist: [
        {
          title: this.$t("servicesystem.common_objects.document.open_in_new_tab"),
          icon: "mdi-open-in-new",
          iconsize: 16,
          hovercolor: "primary",
          method: "openInNewTab"
        },
      ],
      loading: false,
      error: false,
      article: null,
    };
  },

  mounted() {
    this.getArt();
  },

  methods: {
    getArt() {
      if (this.articleNumber) {
        this.loading = true;
        this.error = false;
        this.getArticle(this.articleNumber)
          .then((response) => {
            this.article = response;
          })
          .catch((exception) => {
            console.error(exception);
            this.error = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    open() {
      this.$router.push({ name: "ViewArticle", params: { articleId: this.article.Id, articleNumber: this.articleNumber } });
    },

    openInNewTab() {
      let newPageRoute = this.$router.resolve({ name: "ViewArticle", params: { articleId: this.article.Id, articleNumber: this.articleNumber } });
      window.open(newPageRoute.href, "_blank");
    },
  },

  computed: {},

  watch: {
    articleNumber: function () {
      this.getArt();
    },
  }
};
</script>


<style scoped>
.minitoolbar {
  position: sticky;
  top: 0px;
  z-index: 10;
  box-shadow: 0px 1px 5px var(--v-header-darken2) !important;
}
</style>
